/* eslint-disable react/no-array-index-key */
import { makeStyles } from '@material-ui/core';
import { Children } from 'react';

const POSITION_CLASSES = {
    bottomleft: 'leaflet-bottom leaflet-left',
    bottomright: 'leaflet-bottom leaflet-right',
    topleft: 'leaflet-top leaflet-left',
    topright: 'leaflet-top leaflet-right',
};

const CONTROL_SIZE = 30;

export function Control(props) {
    const { position, containerProps, children } = props;

    return (
        <div className={POSITION_CLASSES[position]}>
            <div className="leaflet-control leaflet-bar" {...containerProps}>
                {children}
            </div>
        </div>
    );
}

const useControlContainerStyles = makeStyles((theme) => ({
    root: {
        marginTop: CONTROL_SIZE * 2.5,
        position: 'relative',
    },

    control: {
        position: 'relative',
        paddingTop: theme.spacing(0.5),
    },
}));

export function ControlContainer(props) {
    const { children } = props;
    const classes = useControlContainerStyles();

    const childrenArr = Children.toArray(children);

    return (
        <div className={classes.root}>
            {childrenArr.map((child, idx) => (
                <div key={idx} className={classes.control} style={{ marginTop: CONTROL_SIZE * idx }}>
                    {child}
                </div>
            ))}
        </div>
    );
}
